// app/javascript/controllers/pages_controllers/grid_carousel_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "slideContainer"]
  static values = {
    interval: Number
  }


  connect() {
    console.log("Grid controller connected")
    if (window.innerWidth < 640) {  // Only activate on mobile (sm breakpoint is 640px)
      this.currentIndex = 0
      this.sliding = false
      this.startAutoPlay()
      
    }
  }

  disconnect() {
    this.stopAutoPlay()
  }

  startAutoPlay() {
    this.autoPlayInterval = setInterval(() => {
      this.next()
    }, this.intervalValue)
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval)
    }
  }

  next() {
    if (this.sliding) return
    
    this.currentIndex++
    if (this.currentIndex >= this.slideTargets.length) {
      this.currentIndex = 0
    }
    this.slide()
  }

  slide() {
    this.sliding = true
    const offset = this.currentIndex * -100
    this.slideContainerTarget.style.transform = `translateX(${offset}%)`
    
    setTimeout(() => {
      this.sliding = false
    }, 500)
  }
}